<template>
	<div class="list_div">
		<div class="item_div" v-for="(item,index) in list">
			<div class="parent_div" @click="parentClick(index)">
				<i :class="selectIndex == index ? 'el-icon-caret-bottom':'el-icon-caret-right'" v-if="item.children&&item.children"/>
				<i class="el-icon-s-unfold" style="font-size: 20px;color: #d8d8d8;" v-else></i>
				<span class="span">{{item.cate_name}}</span>
			</div>
			<div v-if="selectIndex == index" class="children_div" v-for="(item_,index_) in item.children" @click="children(item_.cate_id)">
				<span class="span_">{{item_.cate_name}}</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:{
			list:{
				type:Array
			}
		},
		data(){
			return {
				selectIndex:0
			}
		},
		methods:{
			parentClick(index){
                this.selectIndex = index
				if(!this.list[index].children||!this.list[index].children.length){
					this.children(this.list[index].cate_id)
				}
			},

            children(cate_id){
                console.log('cateClick', cate_id)
                this.$emit('cateClick', cate_id)
            }
		}
	}
</script>

<style scoped>
	.list_div{
		width: 110px;
		display: flex;
		flex-direction: column;
		height: 625;
		max-height: 100%;
		overflow: scroll;
	}
	.item_div{
		display: flex;
		flex-direction: column;
		padding-bottom: 20px;
	}
	.parent_div{
		display: flex;
		flex-direction: row;
	}
	.el-icon-caret-bottom,
	.el-icon-caret-right{
		font-size: 20px;
		color: #d8d8d8;
	}
	.children_div{
		display: flex;
		flex-direction: column;
		padding: 10px 0;
	}
	.span{
		font-size: 14px;
		margin-left: 10px;
		color: #000;
	}
	.span_{
		font-size: 14px;
		margin-left: 30px;
		color: #000;
	}
</style>